;(function ($) {
	$.fn.inViewportAnimate = function () {
		return $(this).each(function () {
			var container = $(this);
			container.inViewport(function (px) {
				if (px) {
					$(this).addClass('animated').addClass($(this).data('inviewportanimate'));
				}
			});
		});
	};
	$(function () {
		$('[data-inviewportanimate]').inViewportAnimate();
	});
})(jQuery);
